import Vue from 'vue'
import App from './App.vue'
import router from './router'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import './styles/brand.css'
import './mock'
import { formatDateTime } from './utils/format'

Vue.config.productionTip = false
Vue.use(ElementUI)

// 全局时间格式化过滤器：将服务端 ISO 时间转为 "YYYY-MM-DD HH:mm:ss"
Vue.filter('formatDateTime', formatDateTime)

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')

